export type EvidenceTriggerLocation = 'in_session' | 'out_of_session' | 'unauthenticated';

export enum EvidenceSBSStreamStatus {
  WAITING_START = 'WAITING_START',
  STREAMING = 'STREAMING',
  DONE = 'DONE',
  ERROR = 'ERROR',
}

export interface EvidenceSBSCandidateView {
  candidate_id: string;
  is_default: boolean;
}

export interface EvidenceSBSSetupResponse {
  candidates: EvidenceSBSCandidateView[];
  generation_mode: string;
}

export interface EvidenceSBSConfirmResponse {
  success: boolean;
}

export interface EvidenceSBSSkipResponse {
  success: boolean;
}

export interface EvidenceSBSCandidate extends EvidenceSBSCandidateView {
  confirmed: boolean;
}
